module.exports = __webpack_public_path__ + "src/assets/video/howToPlaySelectWorker.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/howToPlaySelectWorker.gif
// module id = ./src/assets/video/howToPlaySelectWorker.gif
// module chunks = 0